export default "__VITE_ASSET__4598579e__"